var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetflix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 28,
    viewBox: "0 0 102 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_1303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7741 26.1568C13.2607 26.4228 11.7207 26.5025 10.1277 26.7149L5.26867 12.4711V27.3262C3.75531 27.4856 2.37467 27.6982 0.940887 27.9108V0.698608H4.97679L10.4993 16.1386V0.698608H14.7741V26.1568ZM23.1377 10.664C24.784 10.664 27.3064 10.5843 28.8197 10.5843V14.8361C26.9345 14.8361 24.7309 14.8361 23.1377 14.9158V21.2407C25.6336 21.0813 28.1295 20.8685 30.6517 20.7887V24.881L18.8894 25.8113V0.698608H30.6517V4.95052H23.1377V10.664ZM46.4497 4.95062H42.0422V24.5094C40.6084 24.5094 39.1746 24.5094 37.7942 24.5624V4.95062H33.3867V0.698608H46.4499L46.4497 4.95062ZM53.3529 10.3718H59.1678V14.6236H53.3529V24.2702H49.1841V0.698608H61.0529V4.95052H53.3529V10.3718ZM67.9561 20.5497C70.3724 20.6027 72.8149 20.789 75.1781 20.9217V25.1205C71.3814 24.8812 67.5845 24.6423 63.708 24.5624V0.698608H67.9561V20.5497ZM78.7625 25.4128C80.1166 25.4927 81.5504 25.5724 82.931 25.7316V0.698608H78.7625V25.4128ZM101.544 0.698608L96.1536 13.6404L101.544 27.9108C99.9504 27.6982 98.3573 27.4059 96.7642 27.1401L93.7109 19.2742L90.6047 26.5025C89.0644 26.2365 87.5776 26.1568 86.0379 25.9442L91.5074 13.4808L86.5687 0.698608H91.1353L93.9232 7.84715L96.8971 0.698608H101.544V0.698608Z",
    fill: "#E3E3E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_1303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.603,
    height: 27.2122,
    fill: "white",
    transform: "translate(0.940887 0.698608)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/Netflix.52dfe7b8cc6f0528cdd7d480121e05d8.svg";
export { ForwardRef as ReactComponent };